var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediaEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.849 7.39167C22.4952 2.98292 17.8355 0 12.5 0C7.16449 0 2.50345 2.985 0.151018 7.39208C0.0517307 7.58063 0 7.78894 0 8.00021C0 8.21148 0.0517307 8.41979 0.151018 8.60833C2.50476 13.0171 7.16449 16 12.5 16C17.8355 16 22.4965 13.015 24.849 8.60792C24.9483 8.41937 25 8.21106 25 7.99979C25 7.78852 24.9483 7.58021 24.849 7.39167V7.39167ZM12.5 14C11.2639 14 10.0555 13.6481 9.02768 12.9888C7.99987 12.3295 7.19879 11.3925 6.72574 10.2961C6.25269 9.19974 6.12892 7.99334 6.37008 6.82946C6.61124 5.66557 7.20649 4.59647 8.08057 3.75736C8.95465 2.91824 10.0683 2.3468 11.2807 2.11529C12.4931 1.88378 13.7497 2.0026 14.8918 2.45672C16.0338 2.91085 17.0099 3.67988 17.6967 4.66658C18.3835 5.65327 18.75 6.81331 18.75 8C18.7504 8.78804 18.589 9.56843 18.2751 10.2966C17.9611 11.0247 17.5008 11.6863 16.9203 12.2435C16.3399 12.8007 15.6507 13.2427 14.8922 13.5441C14.1338 13.8455 13.3209 14.0004 12.5 14V14ZM12.5 4C12.1281 4.00499 11.7586 4.05811 11.4015 4.15792C11.6958 4.54195 11.8371 5.01454 11.7996 5.48998C11.7622 5.96542 11.5485 6.41223 11.1973 6.74938C10.8461 7.08652 10.3806 7.29168 9.88539 7.32765C9.39014 7.36362 8.89786 7.22801 8.49782 6.94542C8.27003 7.75108 8.31115 8.60503 8.61539 9.38708C8.91964 10.1691 9.47169 10.8399 10.1938 11.305C10.916 11.7701 11.7719 12.006 12.641 11.9797C13.5102 11.9533 14.3489 11.666 15.039 11.158C15.7291 10.6501 16.236 9.94726 16.4882 9.14833C16.7404 8.3494 16.7253 7.49466 16.445 6.70441C16.1647 5.91415 15.6333 5.22818 14.9256 4.74305C14.2179 4.25791 13.3696 3.99804 12.5 4V4Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaEye);
export default __webpack_public_path__ + "static/media/MediaEye.1d182e11805fbd8123e183051beaf64f.svg";
export { ForwardRef as ReactComponent };